import { render, staticRenderFns } from "./SliderAdsorb.vue?vue&type=template&id=9c0c0b4a&"
import script from "./SliderAdsorb.vue?vue&type=script&lang=js&"
export * from "./SliderAdsorb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports